import AuthService from 'services/AuthService'
import { devS3Url } from 'services/devS3Proxy'

function signedUrlFromBody(data) {
    if (!data || typeof data !== 'object') return null
    return data.signedUrl || data.redirectUrl || null
}

/**
 * GET a private API file URL.
 * After S3 presigned downloads: API returns JSON { signedUrl } — fetch S3 without the JWT.
 * Legacy binary routes (HIPAA, notes, avatars) still return the file bytes.
 */
export async function fetchPrivateBlob(url, token) {
    const response = await fetch(url, {
        headers: {
            Authorization: `Bearer ${token || AuthService.getToken()}`,
        },
    })
    if (!response.ok) {
        throw new Error(`File request failed (${response.status})`)
    }

    const contentType = (response.headers.get('content-type') || '').toLowerCase()
    if (contentType.includes('application/json')) {
        const data = await response.json()
        const signedUrl = signedUrlFromBody(data)
        if (signedUrl) {
            const fileResponse = await fetch(devS3Url(signedUrl))
            if (!fileResponse.ok) {
                throw new Error(`File request failed (${fileResponse.status})`)
            }
            return fileResponse.blob()
        }
        if (data.type === 'Buffer' && Array.isArray(data.data)) {
            return new Blob([Uint8Array.from(data.data)])
        }
        throw new Error('Missing signed URL')
    }

    return response.blob()
}

export async function openPrivateFile(url, token) {
    const blob = await fetchPrivateBlob(url, token)
    const objectUrl = window.URL.createObjectURL(blob)
    window.open(objectUrl, '_blank', 'noopener')
    return objectUrl
}
